// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"168":"dbfbb22e","453":"fd6cc746"}[chunkId] + ".chunk.js";
};